// extracted by mini-css-extract-plugin
module.exports = {"color-circle":"ColorPicker_color-circle__QFGyt"};